import { request, multipartRequest } from "../../api/api"
import axios from "axios";

const url = "https://restcountries.com/v3.1/all";

// userProfile
export const getUserProfileApi = () => {
    return request.get('/dashboard/getUserProfile/')
}

// userprofile Update
export const updateUserProfile = (id, data) => {
    return multipartRequest.put(`/updateWebUserProfile/${id}/`, data)
}

export const updateUserProfileCommunication = (id, data) => {
    return multipartRequest.put(`/updateWebUserProfile/${id}/`, data)
}

// get Country

export const getCountry = () => {
    return axios.get(url)
}

// generateMFA
export const generateMFA = (data) => {
    return request.post('/generateMFA/', data)
}

//verifyMFA
export const verifyMFA = (data) => {
    return request.post('/verifyMFA/', data)
}

// getMobileOTP
export const getMobileOTP = (data) => {
    return request.post('/getMobileOTP/', data)
}

/// verifyMobileOTP
// mfa
export const verify2StepMobileOTP = (data) => {
    return request.post('/verify2StepMobileOTP/', data)
}

// useMobileVerifacation
export const verifyUserMobileOTP = (data) => {
    return request.post('verifyMobileNumber/', data)
}


//get2stepMobileOtp
export const get2StepMobileOTP = (data) => {
    return request.post('/get2StepMobileOTP/', data)
}

//get Country
export const getCountryList = (data) => {
    return request.get('user/getCountryList')
}

//get TimeZoneList 
export const getTimeZoneList = () => {
    return request.get('/getTimeZoneList/')
}